import Cta from "@components/Cta/Cta";
import { NextContentfulImage } from "@components/Image";
import Link from "@components/Link/Link";
import { TypePromotionalManuallyPopulatedFields } from "@customTypes/contentful";
import { ImageWrapperType } from "@customTypes/imageWrapper";
import { Link as LinkType } from "@customTypes/link";
import clsx from "clsx";
import styles from "./C20_PromotionalArticles.module.scss";

export interface PromotionalManuallyPopulatedProps {
  title: string;
  link: LinkType;
  image: ImageWrapperType;
  manualText: string;
  readMoreText: string;
  backgroundColor?: "blue" | "white";
}

export const PromotionalManuallyPopulated = (props: {
  content: TypePromotionalManuallyPopulatedFields;
}) => {
  const { content } = props;
  const { title, link, image, manualText, readMoreText, backgroundColor } =
    content;

  return (
    <div
      className={clsx(
        "component",
        styles["promotional-articles"],
        backgroundColor && styles[backgroundColor]
      )}
    >
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <article>
            {image && (
              <Link href={link.fields.url || "#"}>
                <NextContentfulImage
                  alt={image.fields.altText}
                  // @ts-expect-error type mismatch
                  src={image.fields.url}
                  // @ts-expect-error type mismatch
                  height={image.fields.height}
                  // @ts-expect-error type mismatch
                  width={image.fields.width}
                />
              </Link>
            )}
            <div className={styles.text}>
              {title && link?.fields?.url && (
                <h4>
                  <Link href={link?.fields?.url}>{title}</Link>
                </h4>
              )}
              {manualText && (
                <p dangerouslySetInnerHTML={{ __html: manualText }} />
              )}
              {link && (
                <p>
                  {/* @ts-expect-error type mismatch */}
                  <Cta
                    {...link.fields}
                    linkText={readMoreText}
                    type="tertiary"
                    icon="icon-arrow"
                    light={backgroundColor === "blue"}
                    openInNewTab={link.fields.openInNewTab}
                  />
                </p>
              )}
            </div>
          </article>
        </div>
      </div>
    </div>
  );
};

export default PromotionalManuallyPopulated;
